export const en = {
    // Plantes
    plants: {
        default: { name: 'Basic Plant', description: 'A basic plant that grows easily.' },
        small_blue: { name: 'Small Blue', description: 'A delicate little blue plant.' },
        pink_flower: { name: 'Pink Flower', description: 'A pretty pink flower that attracts butterflies.' },
        rainbow: { name: 'Rainbow', description: 'A plant with rainbow colors.' },
        tall_purple: { name: 'Tall Purple', description: 'A majestic tall purple plant.' },
        rare: { name: 'Rare Plant', description: 'A rare plant that is hard to find and grow.' },
        fire_red: { name: 'Red Flame', description: 'A fiery plant that seems to dance like a flame.' },
        legendary: { name: 'Legendary Plant', description: 'A legendary plant with mysterious properties.' },
        golden_giant: { name: 'Golden Giant', description: 'A giant plant with golden reflections, highly sought after.' }
    },

    // Outils
    tools: {
        auto_gardener: { name: 'Gardening Service', description: 'Performs a gardening click on all your plants every 10 seconds' },
        pruning_shears: { name: 'Pruning Shears', description: 'Allows you to cut a branch to direct growth' },
        fertilizer: { name: 'Fertilizer', description: 'Doubles growth speed for 1 hour' },
        watering_can_upgrade: { name: 'Upgraded Watering Can', description: 'Triples the effect of watering' }
    },

    // Arrière-plans
    backgrounds: {
        background_garden: { name: 'Garden', description: 'A classic green garden' },
        background_forest: { name: 'Forest', description: 'A dense and mysterious forest' },
        background_desert: { name: 'Desert', description: 'An arid and sunny desert' },
        background_beach: { name: 'Beach', description: 'A tropical paradise beach' },
        background_mountains: { name: 'Alpine Mountains', description: 'A fresh valley surrounded by snowy peaks' },
        background_city_garden: { name: 'Urban Garden', description: 'A modern garden in the middle of the city' },
        background_twilight: { name: 'Enchanted Twilight', description: 'A deep purple sky illuminated by fireflies' }
    },

    // Pots
    pots: {
        pot_red: { name: 'Red Pot', description: 'A nice red pot for your plant' },
        pot_blue: { name: 'Blue Pot', description: 'An elegant blue pot for your plant' },
        pot_gold: { name: 'Golden Pot', description: 'A luxurious golden pot for your most beautiful plant' }
    },

    general: {
        loading: 'Loading...'
    },

    // PlantCard
    plantCard: {
        stage: 'Stage',
        mature: 'Mature',
        progression: 'Progress',
        seedProduction: 'Seed production',
        collectSeed: 'Collect seed'
    },

    // Header
    header: {
        title: 'My Pixel Garden',
        myGarden: 'My Garden',
        shop: 'Shop',
        help: 'Help',
        community: 'Community',
        myPublishedPlants: 'My Published Plants',
        myAccount: 'My Account',
        signOut: 'Sign Out',
        saveCtaMobile: 'Sign Up'
    },
    leaveGardenModal: {
        title: 'Leave the garden?',
        body: 'You will lose your garden progress if you leave this page without creating an account.',
        cta: 'Do you want to create a free account to save your garden before continuing?',
        createAccount: 'Create my account',
        quitAndLose: 'Leave and lose everything'
    },
    multiGarden: {
        headerTitle: '🌿 My Pixel Garden',
        publishModalTitle: 'Publish your garden to the community',
        publishModalBody: 'Do you want to share your entire garden with the community? Publishing requires at least one mature plant.',
        loginToPublish: 'Log in to publish',
        publishButton: 'Publish',
        publishButtonLoading: 'Publishing...',
        cancelButton: 'Cancel',
        publishPreviewLabel: 'Preview of your shared garden',
        destroyModalTitle: 'Destroy the plant',
        destroyModalBody: 'Are you sure you want to destroy this plant? This action is irreversible.',
        destroyButton: 'Destroy',
        waterNeedPlant: 'Plant a seed to use the tools.',
        waterReadyPrefix: 'Your water will be recharged in',
        waterNoWater: "You don't have enough water to water.",
        gardenerBadgeTitle: 'Gardening Service',
        gardenerPulse: 'A gardening cycle just passed…',
        gardenerIdleFallback: 'Gardens every 10s',
        cancelButton: 'Cancel',
        destroyModalTitle: 'Destroy the plant',
        destroyModalBody: 'Are you sure you want to destroy this plant? This action is irreversible.',
        destroyButton: 'Destroy',
        waterNeedPlant: 'Plant a seed to use the tools.',
        waterReadyPrefix: 'Your water will be recharged in',
        waterNoWater: "You don't have enough water to water.",
        gardenerBadgeTitle: 'Gardening Service',
        gardenerPulse: 'A gardening cycle just passed…',
        gardenerIdleFallback: 'Gardens every 10s',
        toolHints: {
            sun: 'Sun : click on a plant to accelerate its growth.',
            water: "Water : click on a plant to give it a big boost of growth (consumes water)",
            hand: 'Hand : click on a plant to pull it and collect seeds.',
            pruner: 'Pruner : click on a plant to cut its branches.',
            camera: 'Camera : takes a snapshot of your garden to publish.',
            zoomIn: 'Zoom + : get closer to your garden.',
            zoomOut: 'Zoom - : get further from your garden.'
        }
    },
    landing: {
        heroTitle: 'My Pixel Garden',
        heroSubtitle: 'Grow your virtual garden in pixel art, plant unique plants and share your creations with the community!',
        heroCta: 'Try for free',
        topPlantsTitle: '🌟 Most loved plants',
        topPlantsSubtitle: 'Discover the community favorites',
        topPlantsEmpty: 'Be the first to share your plant!',
        viewGallery: 'see the gallery',
        howItWorksTitle: 'How it works ?',
        plantSeedTitle: 'Plant a seed',
        plantSeedText: 'Drag and drop your seed in the soil to start your adventure',
        growTitle: 'Water and cultivate',
        growText: "Click on the water and sun to make your unique plant grow",
        shareTitle: 'Share',
        shareText: 'Expose your most beautiful plants in the community gallery',
        premiumTitle: 'Premium features',
        autoGardenerTitle: 'Automatic gardener',
        autoGardenerText: "Let your virtual gardener take care of your plants while you're away",
        autoGardenerPrice: 'From 1€/month',
        shopTitle: "Tool shop",
        shopText: 'Unlock special tools, rare seeds and unique cosmetics',
        shopPrice: 'Buy with your seeds',
        ctaTitle: 'Ready to cultivate your garden ?',
        ctaSubtitle: 'Start for free right now, no credit card required',
        ctaButton: 'Start now',
        stageLabel: 'Stage'
    },
    shop: {
        title: 'Shop',
        subtitle: 'Choose a merchant to discover its products',
        autoGrowthLabel: 'Auto growth :',
        perMonth: '/mois',
        popular: 'Popular',
        subscribe: 'Subscribe',
        price: 'Price',
        effect: 'Effect',
        duration: 'Duration',
        permanent: 'Permanent',
        hours: 'hours',
        unlimited: 'Illimité',
        merchants: {
            tools: {
                name: 'Merchant of Tools',
                description: 'Tools to improve your gardening'
            },
            seeds: {
                name: 'Merchant of Seeds',
                description: 'Rare and legendary seeds'
            },
            cosmetics: {
                name: 'Merchant of Cosmetics',
                description: 'Personalize your garden'
            }
        },
        subscriptionsTitle: 'Automatic Gardener Subscriptions',
        plans: {
            basic: {
                name: 'Basic',
                price: '1€',
                description: 'Automatic gardener beginner : 1 click every 5 seconds on each plant.',
                clicks: '1 click / 5 s',
            },
            standard: {
                name: 'Standard',
                price: '3€',
                description: 'Trained gardener : 1 click every 2 seconds to boost growth.',
                clicks: '1 click / 2 s',
            },
            premium: {
                name: 'Premium',
                price: '5€',
                description: 'Expert gardener : 1 click per second on all your plants, even when you are away.',
                clicks: '1 click / second',
            }
        },
        tabs: {
            tools: 'Tools',
            backgrounds: 'Backgrounds',
            pots: 'Pots',
            subscriptions: 'Subscriptions',
            cosmetics: 'Cosmetics'
        },
        items: {
            tools: {
                auto_gardener: {
                    name: 'Gardening Service',
                    description: 'Clicks on all your plants every 10 seconds'
                },
                pruning_shears: {
                    name: 'Pruner',
                    description: 'Allows you to cut a branch to orient growth'
                },
                fertilizer: {
                    name: 'Fertilizer',
                    description: 'Double the growth speed for 1 hour'
                },
                watering_can_upgrade: {
                    name: 'Watering Can Upgrade',
                    description: 'Triples the effect of watering on your plants'
                }
            },
            backgrounds: {
                garden: {
                    name: 'Classic Garden',
                    description: 'A verdant garden to cultivate your plants'
                },
                forest: {
                    name: 'Enchanted Forest',
                    description: 'A mysterious forest full of magic and mysteries'
                },
                desert: {
                    name: 'Dry Desert',
                    description: 'A hot and sunny desert landscape'
                },
                beach: {
                    name: 'Paradise Beach',
                    description: 'A fine sand beach with a crystal clear sea'
                },
                mountains: {
                    name: 'Alpine Peaks',
                    description: 'A panoramic view of snow-capped mountains'
                },
                mountain: {
                    name: 'Majestic Mountain',
                    description: 'A panoramic view of snow-capped mountains'
                },
                city_garden: {
                    name: 'Urban Garden',
                    description: 'A green space at the heart of the city'
                },
                twilight: {
                    name: 'Enchanted Twilight',
                    description: 'A purple sky illuminated by stars'
                }
            },
            pots: {
                pot_red: {
                    name: 'Red Pot',
                    description: 'A beautiful red pot to highlight your plants'
                },
                pot_blue: {
                    name: 'Blue Pot',
                    description: 'An elegant blue pot for your most beautiful plants'
                },
                pot_gold: {
                    name: 'Gold Pot',
                    description: 'A luxurious gold pot for your rarest plants'
                }
            }
        },
        purchaseButton: 'Buy',
        ownedLabel: 'Already owned',
        selectLabel: 'Select'
    },
    community: {
        title: 'Community Gardens',
        subtitle: 'Discover the most beautiful gardens created by the community',
        successTitle: 'Jardin publié !',
        successDescription: 'Votre jardin est maintenant visible dans la communauté',
        emptyTitle: "Aucun jardin n'a encore été publié",
        emptySubtitle: 'Soyez le premier à partager votre jardin !',
        cardOwnerUnknown: 'Anonyme',
        cardPlantSingular: 'plante dans le jardin',
        cardPlantPlural: 'plantes dans le jardin',
        likeButtonLoggedIn: 'Liker ce jardin',
        likeButtonLoggedOut: 'Connectez-vous pour liker'
    },
    published: {
        title: 'My plants',
        subtitle: 'Manage your shared gardens in the community',
        emptyTitle: "You haven't published any gardens yet",
        emptyCta: 'Back to garden',
        stageLabel: 'Stage',
        likeLabel: 'Likes',
        publishedLabel: 'Published on',

        // Boutons
        sacrificeButton: 'Sacrify the garden',
        deleteButton: 'Delete',
        deleteConfirm: 'Delete',
        cancel: 'Cancel',

        // Modale de suppression
        deleteModalTitle: 'Delete the plant',
        deleteModalBody: 'Are you sure you want to delete this plant? This action is irreversible and you will not receive any seeds.',
        deleting: 'Deleting...',
        deleteError: 'Error deleting',

        // Modale de sacrifice
        sacrificeModalTitle: 'Sacrify the garden',
        sacrificeReward: 'Sacrify this garden will give you',
        sacrificeRewardIntro: 'Sacrify this garden will give you',
        sacrificeCalc: 'Calcul :',
        sacrificing: 'Sacrifying...',
        sacrificeError: 'Error sacrificing',
        confirmSacrifice: 'Confirm sacrifice',
        selectGardenToSacrifice: 'Select a garden to sacrifice.',

        // Termes pour le calcul des récompenses
        seedSingular: 'seed',
        seedPlural: 'seeds',
        matureSingular: 'mature plant',
        maturePlural: 'mature plants',
        likeSingular: 'like',
        likePlural: 'likes',
        rewardCalcPrefix: 'Calcul :',
        selectGardenPrompt: 'Select a garden to sacrifice.'
    },
    account: {
        title: 'My account',
        personalInfoTitle: 'Personal information',
        usernameLabel: "Username",
        usernameFallback: 'Not defined',
        emailLabel: 'Email',
        editProfile: 'Edit profile',
        subscriptionTitle: 'Subscription',
        subscriptionActive: 'Active subscription',
        subscriptionRenew: 'Renewal on',
        manageSubscription: 'Manage subscription',
        noSubscription: "You don't have an active subscription. Subscribe to a subscription to benefit from the automatic gardener!",
        viewPlans: 'View subscriptions',
        dangerZoneTitle: 'Danger zone',
        signOut: 'Sign out'
    },
    seedSelector: {
        noSeeds: "You don't have any seeds.",
        growPlantToGetSeeds: 'Grow a plant to get some!',
        defaultSeedName: 'Seed',
        plant: 'Plant',
        noPlantsYet: 'No plants yet. Select a seed and click on the canvas to plant!'
    },
    saveProgressPrompt: {
        title: 'Save your progress ?',
        progressMade: 'You have made progress in your garden!',
        createAccountToSave: 'Create a free account to save your progress and access it from anywhere.',
        yourProgress: 'Your progress :',
        growingPlant: 'A plant in progress',
        seed: 'seed',
        seed_plural: 'seeds',
        createAccountFree: 'Create a free account (free)',
        continueWithoutSaving: 'Continue without saving'
    },
    footer: {
        brand: {
            title: 'My Garden Pixel',
            description: 'Grow your virtual garden in pixel art and share your creations with the community.'
        },
        usefulLinks: {
            title: 'Useful links',
            help: 'Help & FAQ',
            community: 'Community',
            shop: 'Shop'
        },
        legal: {
            title: 'Legal',
            terms: "Terms of use",
            privacy: 'Privacy policy'
        },
        copyright: 'My Garden Pixel. All rights reserved.'
    },
    help: {
        title: 'Help & FAQ',
        subtitle: 'All you need to know to grow your garden',
        gameMechanics: {
            title: 'Game mechanics',
            plant: {
                title: 'Plant',
                description: 'Drag a seed into the soil to start growing your unique plant.'
            },
            water: {
                title: 'Water',
                description: 'Watering gives a growth bonus to your plant.'
            },
            sun: {
                title: 'Sun',
                description: 'Each click on the sun progresses the growth of your plant.'
            },
            prune: {
                title: 'Prune',
                description: 'Use the pruner to orient the growth of your plant.'
            },
            shop: {
                title: 'Shop',
                description: 'Buy tools, rare seeds and cosmetics with your seeds.'
            },
            community: {
                title: 'Community',
                description: 'Share your plants and like those of other gardeners.'
            }
        },
        faq: {
            title: 'Frequently asked questions',
            faqs: {
                howToPlant: {
                    question: 'How to plant a seed ?',
                    answer: 'Drag a seed from your inventory to the soil, or click on the "Plant a seed" button.'
                },
                howToGrow: {
                    question: 'How to make my plant grow ?',
                    answer: 'Click on the sun to make your plant grow and use the water drop as soon as your reserve is available (the button shows the remaining time when the reservoir is empty).'
                },
                howToGetSeeds: {
                    question: 'How to get seeds ?',
                    answer: 'Each mature plant prepares a seed with the time. The gardening service automatically collects those ready, even if you are on another page. You can also buy specific seeds in the shop.'
                },
                seedPurpose: {
                    question: 'What are seeds for ?',
                    answer: 'Seeds are currency in the game. You can use them to buy tools, rare seeds and cosmetics.'
                },
                autoGardener: {
                    question: 'What is the automatic gardener ?',
                    answer: 'There are two options : a permanent service to buy with seeds (1 click every 10 seconds on all your plants) and monthly subscriptions (Basic 1 click/5 seconds, Standard 1 click/2 seconds, Premium 1 click/second). They continue to work and collect when you are not in the garden.'
                },
                howToolsWork: {
                    question: 'How do tools work ?',
                    answer: 'The seeder, fertilizer and improved watering must be bought in the tool shop. The seeder unlocks the possibility of cutting branches. The fertilizer activates immediately after purchase (bonus x2 during 1 hour then available again). The improved watering multiplies the efficiency of each watering for life.'
                },
                howToShare: {
                    question: 'How to share my plant ?',
                    answer: 'Once your plant is mature, click on "Publish in the community" to share it in the public gallery.'
                },
                prunerPurpose: {
                    question: 'What is the pruner for ?',
                    answer: 'After buying it in the tool shop, it allows you to cut branches to orient the growth of your plant.'
                }
            }
        }
    },
    terms: {
        title: 'Terms of Use',
        localeCode: 'en-US',
        acceptance: {
            title: '1. Acceptance of conditions',
            content: 'By accessing and using My Garden Pixel, you accept to be bound by these general terms of use. If you do not accept these conditions, please do not use our service.'
        },
        serviceDescription: {
            title: '2. Service description',
            content: 'My Garden Pixel is an idle clicker game allowing users to cultivate virtual plants in pixel art. The service is accessible via web browser and mobile devices.'
        },
        userAccount: {
            title: '3. Account',
            content: 'To access certain features, you must create an account. You are responsible for the confidentiality of your identifiers and all activities performed under your account.'
        },
        subscriptions: {
            title: '4. Subscriptions and payments',
            content: 'The automatic gardener subscriptions are billed monthly via Stripe. You can cancel your subscription at any time. Payments are non-refundable except for legal disposition.'
        },
        intellectualProperty: {
            title: '5. Intellectual property',
            content: 'All game contents, including graphics, code and game mechanics, are the property of My Garden Pixel. The plants created by users remain their property.'
        },
        userConduct: {
            title: '6. User conduct',
            content: 'You engage to not use the service abusively, illegally or against ethics. We reserve the right to suspend or delete any account in case of violation of these conditions.'
        },
        liability: {
            title: '7. Limitation of liability',
            content: 'My Garden Pixel is provided "as is" without any warranty of any kind. We are not liable for any direct or indirect damages resulting from the use of the service.'
        },
        modifications: {
            title: '8. Modifications',
            content: 'We reserve the right to modify these conditions at any time. The modifications will take effect as soon as they are published on the site.'
        },
        contact: {
            title: '9. Contact',
            content: 'Pour toute question concernant ces conditions, veuillez nous contacter à l\'adresse : contact@monjardinpixel.com'
        },
        lastUpdated: 'Dernière mise à jour : {{date}}'
    },
    privacy: {
        title: 'Privacy Policy',
        localeCode: 'en-US',
        dataCollection: {
            title: '1. Data collection',
            intro: 'We collect the following information when you use My Garden Pixel:',
            email: 'Email and username at registration',
            gameData: 'Game data (plants, seeds, progress)',
            payment: 'Payment information (processed securely by Stripe)',
            analytics: 'Usage data and anonymized statistics'
        },
        dataUsage: {
            title: '2. Data usage',
            intro: 'Your data is used for:',
            provideService: 'Provide and improve our services',
            manageAccount: 'Manage your account and subscriptions',
            communication: 'Communicate with you regarding the service',
            analytics: 'Analyze game usage to improve the experience'
        },
        dataSharing: {
            title: '3. Data sharing',
            intro: 'We never sell your personal data. Your information can only be shared with:',
            stripe: 'Stripe for payment processing',
            supabase: 'Supabase for secure data hosting',
            legal: 'Legal authorities if required by law'
        },
        security: {
            title: '4. Security',
            content: 'We implement technical and organizational security measures to protect your data against unauthorized access, modification, disclosure, or destruction.'
        },
        cookies: {
            title: '5. Cookies',
            content: 'We use essential cookies for the operation of the game, notably to maintain your connection session and save your preferences.'
        },
        gdpr: {
            title: '6. Your rights (GDPR)',
            intro: 'Under the General Data Protection Regulation (GDPR), you have the following rights:',
            access: 'Right to access your personal data',
            rectification: 'Right to rectify your data',
            erasure: 'Right to erasure of your data',
            portability: 'Right to portability of your data',
            objection: 'Right to object to the processing of your data',
            contact: 'To exercise these rights, contact us at : privacy@monjardinpixel.com'
        },
        dataRetention: {
            title: '7. Data retention',
            content: 'We keep your data as long as your account is active. If you delete your account, your data will be deleted within 30 days.'
        },
        modifications: {
            title: '8. Modifications',
            content: 'This privacy policy can be updated. We will inform you of any significant changes by email or through a notification in the game.'
        },
        contact: {
            title: '9. Contact',
            content: 'For any question regarding this privacy policy, contact us at : privacy@monjardinpixel.com'
        },
        lastUpdated: 'Last updated : {{date}}'
    },
    seedInventory: {
        title: 'Seeds',
        availableAllSeeds: 'Available (all seeds):',
        cancel: 'Cancel'
    },
    plantList: {
        title: 'Plants in the garden',
        noPlants: 'No plants. Select a seed and click on the canvas to plant !'
    },
    plantCard: {
        stage: 'stage',
        mature: 'mature',
        progression: 'progression',
        seedProduction: 'seed production',
        collectSeed: 'Collect seed'
    },
    waterLevelGauge: {
        waterLevel: "Water level"
    },
    modeSelector: {
        sun: 'Sun',
        water: 'Water'
    },
    freeSeedClaim: {
        freeSeed: 'Free seed',
        description: 'A Basic Plant seed is given every 13 hours',
        claimed: 'Seed claimed successfully!',
        free: 'FREE',
        claim: 'Claim',
        nextSeedIn: 'Next seed in :',
        unavailable: 'Unavailable'
    },
    profile: {
        title: 'Public Profile',
        updateSuccess: 'Profile updated successfully!',
        updateError: 'Error updating profile',
        usernameLabel: "Username",
        usernamePlaceholder: 'Your username',
        bioLabel: 'Biography',
        bioPlaceholder: 'Tell us about yourself...',
        characters: 'characters',
        avatarUrlLabel: "Avatar URL",
        saveButton: 'Save modifications'
    },
    auth: {
        usernameLabel: "Username",
        usernamePlaceholder: 'Your username',
        emailLabel: 'Email',
        emailPlaceholder: 'your@email.com',
        resetEmailSent: 'Reset email sent! Check your email to confirm your registration.',
        signIn: 'Sign In',
        signUp: 'Sign Up',
        saveProgress: 'Save your progress',
        resetPassword: 'Reset password',
        passwordLabel: 'Password',
        passwordPlaceholder: '••••••••',
        signInButton: 'Sign In',
        signUpButton: "Sign Up",
        sendLinkButton: 'Send link',
        forgotPassword: 'Forgot password ?',
        noAccount: 'No account ?',
        hasAccount: 'Already have an account ?',
        backToSignIn: 'Back to sign in'
    },
    inlineAuth: {
        progress: {
            title: 'Progression',
            growingPlant: 'A growing plant',
            seedSingular: 'seed',
            seedPlural: 'seeds',
            footer: 'Create a free account to never lose your progress!'
        },
        messages: {
            accountCreated: 'Account created! Check your email to confirm your registration.'
        },
        errors: {
            usernameRequired: "Username is required",
            generic: 'An error occurred'
        }
    },
    myGarden: {
        mustBeLoggedInToPublish: 'You must be logged in to publish your plant.',
        publishPlantTitle: 'Publish your plant',
        publishPlantDescription: 'Your plant will be visible in the community gallery. Other players will be able to like it!'
    },
    merchant: {
        confirmButton: 'Confirm',
        backButton: 'Back',
        toolsMerchant: "Tools Merchant",
        seedsMerchant: 'Seeds Merchant',
        cosmeticsMerchant: 'Cosmetics Merchant',
        defaultMerchant: 'Merchant',
        basicSeedsLabel: 'Your basic seeds:',
        noItemsAvailable: 'No items available at the moment',
        owned: 'Owned',
        active: 'Active',
        alreadyOwned: 'Already owned',
        notEnoughSeeds: 'Not enough seeds',
        buyButton: 'Buy',
        confirmPurchaseTitle: "Confirm purchase",
        activeEffect: 'Active effect... come back later to buy it again',
        clickInfo: 'click(s) every'
    },
    gameConfig: {
        plants: {
            default: 'Basic Plant',
            small_blue: 'Small Blue',
            pink_flower: 'Pink Flower',
            rainbow: 'Rainbow',
            tall_purple: 'Tall Purple',
            rare: 'Rare Plant',
            fire_red: 'Fire Red',
            legendary: 'Legendary Plant',
            golden_giant: 'Golden Giant'
        },
        tools: {
            auto_gardener: {
                name: 'Auto Gardener',
                description: 'Clicks on all your plants every 10 seconds'
            },
            pruning_shears: {
                name: 'Pruning Shears',
                description: 'Allows you to cut a branch to orient growth'
            },
            fertilizer: {
                name: 'Fertilizer',
                description: 'Double la vitesse de croissance pendant 1 heure'
            },
            watering_can_upgrade: {
                name: 'Watering Can Upgrade',
                description: 'Triple l\'effet de l\'arrosage'
            }
        },
        seeds: {
            small_blue_seed: {
                name: 'Seed Blue',
                description: 'A small blue seed'
            },
            pink_flower_seed: {
                name: 'Seed Pink Flower',
                description: 'A pink flower seed'
            },
            rainbow_seed: {
                name: 'Seed Rainbow',
                description: 'A rainbow seed'
            },
            fire_red_seed: {
                name: 'Seed Flamme Rouge',
                description: 'A red seed'
            },
            rare_seed: {
                name: 'Rare Seed',
                description: 'A rare seed'
            },
            legendary_seed: {
                name: 'Legendary Seed',
                description: 'A legendary seed'
            },
            golden_giant_seed: {
                name: 'Golden Giant Seed',
                description: 'The biggest and most majestic seed'
            }
        },
        cosmetics: {
            pot_red: {
                name: 'Red Pot',
                description: 'A beautiful red pot for your plant'
            },
            pot_blue: {
                name: 'Blue Pot',
                description: 'A beautiful blue pot for your plant'
            },
            background_garden: {
                name: 'Garden',
                description: 'A beautiful garden'
            },
            background_forest: {
                name: 'Forest',
                description: 'A dense and mysterious forest'
            },
            background_desert: {
                name: 'Desert',
                description: 'An arid and sunny desert'
            },
            background_beach: {
                name: 'Beach',
                description: 'A tropical paradise beach'
            },
            background_mountains: {
                name: 'Mountain Garden',
                description: 'A fresh valley surrounded by snow-capped peaks'
            },
            background_city_garden: {
                name: 'City Garden',
                description: 'A modern garden in the city'
            },
            background_twilight: {
                name: 'Twilight Garden',
                description: 'A twilight garden illuminated by fireflies'
            }
        },
        subscriptions: {
            basic: 'Gardener Basic',
            standard: 'Gardener Standard',
            premium: 'Gardener Premium'
        }
    },
    herbarium: {
        title: 'Herbarium',
        viewButton: 'View',
        modalTitle: 'Herbarium',
        progressLabel: 'Species discovered',
        emptyStateTitle: 'No plants discovered',
        emptyStateBody: 'Grow a plant to reveal its appearance here.',
        unknownName: '???',
        unknownDescription: 'Cultive cette plante pour dévoiler son visuel.',
        discoveredOn: 'Découvert le'
    }
};